document.addEventListener("DOMContentLoaded" , function(){

    scrollNav();
    navegacionFija();

})

function navegacionFija(){

    
    const barra = document.querySelector(".header");

    const observer = new IntersectionObserver(function(entries){

        if (entries[0].isIntersecting){

            barra.classList.remove("fijo")

        } else{

            barra.classList.add("fijo")

        }
            

    })

    observer.observe(document.querySelector(".intro_description"));

}


function scrollNav(){


const enlaces = document.querySelectorAll(".navegacion-principal a");

enlaces.forEach( function(enlace){

    enlace.addEventListener("click", function(e){

        e.preventDefault()
       
        const seccion = document.querySelector(e.target.attributes.href.value)

        seccion.scrollIntoView({ 
            
            behavior: "smooth", 
            //behavior: "",
        
        
        
        }); // Para qued deslice 

        });

    });
};